export default "/images/vendor/flag-icon-css/flags/1x1/za.svg?8a405db0d230f726cb0c57d10c47ad3e";